import Validator from './validator'
import {IValidatorOptionsSimple} from "~/interfaces/validatorInterfaces"

export default abstract class RegexValidator<R, Simple extends IValidatorOptionsSimple<R> = IValidatorOptionsSimple<R>> extends Validator<R, Simple> {
  abstract matcher: RegExp
  messageTemplate: string = 'Please enter %{suffix}'
  buildMessage: (interpolations: Record<'suffix', string>) => string

  protected test(value: string): boolean {
    return this.matcher.test(value)
  }
}